import { ObjectivesHero } from './ObjectivesHero';
import { PillarContributions } from './PillarContributions';
import { useEmployeePortalObjectives } from './useEmployeePortalObjectives';
import { YourObjectives } from './YourObjectives';

import { useGetCompanyInformation } from '@/api/directory';
import { useStrategicVision } from '@/hooks/objectives/useStrategicVision';
import { getLocalizedText } from '@/utils/localization';

/**
 * The portal's Objectives tab: what the employee's objectives serve and how far they have come, the
 * strategic pillars they feed, then the objectives themselves.
 */
export const EmployeePortalObjectivesTab = () => {
    const strategicVision = useStrategicVision();
    const { data: company } = useGetCompanyInformation();
    const {
        periodId,
        objectives,
        summary,
        isSummaryKnown,
        isLoadingObjectives,
        areObjectivesUnavailable,
        pillars,
        contributingPillarIds,
    } = useEmployeePortalObjectives();

    // The portal breathes wider than the rest of the module between its sections: 32px on a phone,
    // 56px from `md`. Those are the `gap-8` and `gap-14` steps.
    return (
        <div className={'flex flex-col max-md:gap-[32px] md:gap-[56px]'}>
            <ObjectivesHero
                summary={summary}
                isSummaryKnown={isSummaryKnown}
                companyName={getLocalizedText(company?.company.names)}
                strategicVision={strategicVision}
            />

            <PillarContributions
                summaries={pillars.summaries}
                isKnown={pillars.isKnown}
                isError={pillars.isError}
                contributingPillarIds={contributingPillarIds}
            />

            <YourObjectives
                objectives={objectives}
                isLoading={isLoadingObjectives}
                isError={areObjectivesUnavailable}
                periodId={periodId}
            />
        </div>
    );
};
